const hi = {
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '7 इमर्सिव भूगोल खेल।',
  'home.subtitle.line2':  '1 दुनिया। 5 स्तर। अनंत विस्मय।',
  'home.tagline.line1':   'सात गेम, एक ग्रह।',
  'home.tagline.line2':   'धरती के हर कोने को खोजें — प्रतिस्पर्धा करें, अंक कमाएँ, अपना साम्राज्य जीतें।',
  'home.footer.company':  'कंपनी',
  'home.footer.legal':    'क़ानूनी',
  'home.footer.about':    'हमारे बारे में',
  'home.footer.contact':  'संपर्क',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  'गोपनीयता',
  'home.footer.terms':    'शर्तें',
  'home.footer.cookies':  'Cookies',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      'हमारी Android ऐप के शुरुआती टेस्टर बनें',
  'home.beta.text':       'Founder बैज, लाइफ़टाइम Premium, और ऊपर लिखे लकी ड्रॉ पुरस्कारों का मौका पाएं।',
  'home.beta.cta':        'BETA प्रोग्राम',

  'common.start':         'शुरू करें',
  'common.startBig':      '▶ शुरू करें',
  'common.back':          'वापस',
  'common.home':          'होम',
  'common.howToPlay':     'कैसे खेलें',
  'common.gotIt':         'समझ गया — खेल पर वापस',
  'common.next':          'अगला',
  'common.restart':       'फिर से शुरू',
  'common.tryAgain':      'फिर कोशिश करें',
  'common.playAgain':     'फिर खेलें',
  'common.mainMenu':      'मुख्य मेनू',
  'common.quit':          'बाहर',
  'common.play':          'खेलें',
  'common.unlock':        '🔒 Premium से अनलॉक करें',
  'common.language':      'भाषा',

  'rules.kicker.goal':         'लक्ष्य',
  'rules.kicker.howToPlay':    'कैसे खेलें',
  'rules.kicker.levels':       'स्तर',
  'rules.kicker.tips':         'सुझाव',
  'rules.gameNotFound':        'खेल नहीं मिला',
  'rules.points':              'अंक',

  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     'अपनी जड़ें खोजें',
  'games.origin.description': 'दुनिया में कहीं पर भी एक यादृच्छिक स्ट्रीट व्यू स्थान। नक़्शे पर जगह को चिह्नित करें। 5 स्तरों में 100 किमी → 1 किमी सटीकता।',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'GPS शैली का खज़ाना खोज',
  'games.hunt.description':   'किसी असली स्थलचिन्ह के पास उतारा जाता है। स्ट्रीट व्यू में चलकर उसे ढूँढिए। स्तर बढ़ने पर कम्पास कम मदद करता है।',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      'सुरागों को पढ़ें',
  'games.photo.description':  'एक स्थिर स्ट्रीट व्यू तस्वीर — कोई पैन नहीं, कोई हलचल नहीं। साइन, पौधे, सूर्य की दिशा पढ़ें। 30 सेकंड से 5 सेकंड की झलक तक।',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    'पृथ्वी को फिर से जोड़ें',
  'games.pangaea.description':'3D ग्लोब के चारों ओर महाद्वीप और द्वीप तैर रहे हैं। उन्हें वापस जगह पर खींचें — आज की स्थिति या प्राचीन पैंजिया।',

  'rules.origin.goal': 'पृथ्वी पर एक यादृच्छिक स्ट्रीट व्यू में आप उतारे जाते हैं। विश्व मानचित्र पर खुद को जितना सटीकता से पिन करें।',
  'rules.origin.step1': 'पैनोरामा देखें। साइन पढ़ें, लेन गिनें, आसमान में सूर्य की दिशा देखें।',
  'rules.origin.step2': 'मिनी मानचित्र पर क्लिक करके पिन लगाएं।',
  'rules.origin.step3': 'जमा करें। आपका पिन असली जगह के जितना पास, उतने अंक।',
  'rules.origin.step4': 'स्तर जुड़े हैं — दूरी की सीमा पार करके अगला अनलॉक करें।',
  'rules.origin.level1': '100 किमी के भीतर',
  'rules.origin.level2': '50 किमी के भीतर',
  'rules.origin.level3': '25 किमी के भीतर',
  'rules.origin.level4': '10 किमी के भीतर',
  'rules.origin.level5': '1 किमी के भीतर',
  'rules.origin.tip1': 'चलने की दिशा, नंबर प्लेट, सड़क पर निशानों के रंग से देश का पता तेज़ी से चलता है।',
  'rules.origin.tip2': 'वनस्पति + सूर्य की ऊँचाई अक्षांश घटाते हैं। सड़क के साइन शहर तय करते हैं।',
  'rules.origin.tip3': 'Master Geographer (L5 = 1 किमी) कठोर है — अधिकांश रन L3 या L4 पर रुकते हैं।',

  'rules.hunt.goal': 'स्ट्रीट व्यू में आपको असली स्थलचिन्ह के पास रखा जाता है। पैनोरामा में चलकर उस पर खड़े हो जाएं। ऊँचे स्तरों पर कम्पास कम मदद करता है।',
  'rules.hunt.step1': 'ऊपर पट्टी में लक्ष्य का नाम पढ़ें।',
  'rules.hunt.step2': 'कम्पास तीर + दूरी का प्रयोग करके दिशा निर्धारित करें।',
  'rules.hunt.step3': 'स्ट्रीट व्यू में चलने के लिए तीरों पर क्लिक करें।',
  'rules.hunt.step4': 'खोज क्षेत्र के अंदर "मिल गया!" बटन सक्रिय होगा — दबाएं और अंक पाएं।',
  'rules.hunt.level1': '5 किमी · 10 मिनट · विश्व प्रसिद्ध · तीर + सटीक दूरी · 100 मी खोज क्षेत्र',
  'rules.hunt.level2': '15 किमी · 12 मिनट · विश्व प्रसिद्ध · तीर + गोल दूरी',
  'rules.hunt.level3': '25 किमी · 12 मिनट · देश में प्रसिद्ध · केवल कम्पास, बिना दूरी',
  'rules.hunt.level4': '50 किमी · 15 मिनट · देश में प्रसिद्ध · गर्म/ठंडा संकेत',
  'rules.hunt.level5': '50 किमी · 10 मिनट · अल्पज्ञात · केवल POI नाम, GPS नहीं',
  'rules.hunt.tip1': 'L4–L5 में 3 Compass Ping मिलते हैं — तीर की चमक, सावधानी से उपयोग करें।',
  'rules.hunt.tip2': 'मध्य-बिंदु बोनस: आधा रास्ता पार करने पर +2 मिनट।',
  'rules.hunt.tip3': 'जब केवल नाम हो, स्मृति या परिवेश देखें — कई स्थलचिन्ह दूर से भी पहचाने जाते हैं।',

  'rules.photo.goal': 'आप एक स्थिर स्ट्रीट व्यू फ्रेम देखते हैं — कोई पैन नहीं, कोई हलचल नहीं। साइन, पौधे, सूर्य दिशा और सड़क के निशानों से जगह का अनुमान लगाएं।',
  'rules.photo.step1': 'पहले एक क्षेत्र चुनें (विश्व, यूरोप, एशिया आदि) — यह खोज क्षेत्र तय करता है।',
  'rules.photo.step2': 'फ़ोटो एक निश्चित अवलोकन समय के लिए दिखती है। हर सेकंड का उपयोग करें।',
  'rules.photo.step3': 'टाइमर के बाद नक़्शा आता है। अपना सबसे अच्छा अनुमान पिन करें।',
  'rules.photo.step4': 'जितना पास = उतने अंक। परिणाम स्क्रीन पर फ़ोटो फिर दिखाई जाती है।',
  'rules.photo.level1': '30 सेकंड अवलोकन · 1 000 किमी सटीकता',
  'rules.photo.level2': '20 सेकंड · 500 किमी',
  'rules.photo.level3': '15 सेकंड · 250 किमी',
  'rules.photo.level4': '10 सेकंड · 100 किमी',
  'rules.photo.level5': '5 सेकंड की झलक · 50 किमी',
  'rules.photo.tip1': 'साइन की भाषा सबसे तेज़ सुराग है। एक शब्द ही अक्सर देश तय कर देता है।',
  'rules.photo.tip2': 'सूर्य की दिशा बताती है कि दक्षिण कहाँ (उत्तरी गोलार्ध) या उत्तर (दक्षिणी गोलार्ध)।',
  'rules.photo.tip3': 'बिजली के खंभों का आकार, सड़क के निशान और नंबर प्लेट आश्चर्यजनक रूप से जानकारीपूर्ण होते हैं।',

  'rules.pangaea.goal': '3D पृथ्वी, छह महाद्वीप। प्रत्येक को स्तर की कोणीय सहनशीलता के भीतर रखें — आधुनिक स्थिति या 30 करोड़ साल पहले पैंजिया में।',
  'rules.pangaea.step1': 'दाईं सूची से एक महाद्वीप चुनें।',
  'rules.pangaea.step2': 'ग्लोब पर वहाँ क्लिक करें जहाँ आपको लगता है यह जाता है।',
  'rules.pangaea.step3': 'सहनशीलता के भीतर → स्थिर हो जाता है। नहीं तो → लाल फीडबैक, फिर कोशिश।',
  'rules.pangaea.step4': 'प्रति महाद्वीप 3 प्रयास। 6 में से कम से कम 5 आगे बढ़ने के लिए।',
  'rules.pangaea.level1': 'महाद्वीप · आज · 25° सहनशीलता',
  'rules.pangaea.level2': 'आज · 18° सहनशीलता',
  'rules.pangaea.level3': 'आज · 12° सटीक',
  'rules.pangaea.level4': 'पैंजिया · प्राचीन · 25° सहनशीलता',
  'rules.pangaea.level5': 'पैंजिया · प्राचीन · 18° सटीक',
  'rules.pangaea.tip1': 'घुमाने के लिए ग्लोब खींचें। ज़ूम के लिए स्क्रॉल करें।',
  'rules.pangaea.tip2': 'पैंजिया स्तरों में महाद्वीप दक्षिणी गोलार्ध में एकत्रित थे — अफ्रीका और दक्षिण अमेरिका जुड़े थे, भारत पूर्वी अफ्रीका के पास, उत्तर अमेरिका यूरोप से सटा।',
  'rules.pangaea.tip3': 'अंटार्कटिका लगभग भूमध्य रेखा पर थी। ऑस्ट्रेलिया उसके नीचे चिपका हुआ था।',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        'प्रतीक को पहचानो',
  'games.landmark.description':    'किसी प्रसिद्ध इमारत या स्मारक की तस्वीर — पहचानो और विश्व मानचित्र पर पिन लगाओ। Photo Detective की तरह 5 स्तर।',
  'rules.landmark.goal':           'एक प्रसिद्ध स्मारक की तस्वीर दिखती है। विश्व मानचित्र पर वहाँ पिन लगाओ जहाँ तुम सोचते हो वह है।',
  'rules.landmark.step1':          'कुछ सेकंड तस्वीर देखो। इमारत को पहचानो, संदर्भ पढ़ो।',
  'rules.landmark.step2':          'टाइमर खत्म होने पर मानचित्र दिखता है।',
  'rules.landmark.step3':          'पिन लगाओ और सबमिट करो। जितना पास, उतने ज़्यादा अंक।',
  'rules.landmark.step4':          'पाँच स्तर। हर स्तर पिछले से छोटा और कठिन।',
  'rules.landmark.level1':         '30 सेकंड देखने के लिए · सटीकता 1 000 किमी',
  'rules.landmark.level2':         '20 सेकंड · 500 किमी',
  'rules.landmark.level3':         '15 सेकंड · 250 किमी',
  'rules.landmark.level4':         '10 सेकंड · 100 किमी',
  'rules.landmark.level5':         '5 सेकंड की झलक · 50 किमी',
  'rules.landmark.tip1':           'विशिष्ट आकार (एफिल, पिरामिड) तुरंत पहचान आते हैं — अंक सटीक पिन से आते हैं।',
  'rules.landmark.tip2':           'कम प्रसिद्ध स्मारक: संदर्भ पढ़ो — जलवायु, वास्तुशिल्प, परिवेश।',
  'rules.landmark.tip3':           'तस्वीरें विकिपीडिया से CC-BY-SA लाइसेंस पर। श्रेय चिप दबाकर स्रोत देखें।',

  'paywall.title':        "यह गेम Premium है",
  'paywall.text':         "खेलते हुए अर्जित पॉइंट्स से इस गेम को अनलॉक करें।",
  'paywall.cta':          "BETA प्रोग्राम में शामिल हों",
  'paywall.dismiss':      "शायद बाद में",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "बहुविकल्पी",
  'games.spot.description': "किसी प्रसिद्ध इमारत या स्मारक की तस्वीर — 3-6 विकल्पों में से सही जवाब चुनें। अनंत मोड, हर राउंड कठिन।",

  'rules.spot.goal':   "फ़ोटो देखकर सही स्थल चुनें। एक ग़लती और रन ख़त्म।",
  'rules.spot.step1':  "क्षेत्र चुनें (विश्व, यूरोप, एशिया…) — पूल उस महाद्वीप तक सीमित।",
  'rules.spot.step2':  "प्रसिद्ध स्थल की तस्वीर एक प्रश्न के साथ आती है।",
  'rules.spot.step3':  "विकल्पों में से सही उत्तर पर टैप करें।",
  'rules.spot.step4':  "सिलसिला बनाए रखें — हर लेवल पर एक विकल्प (अधिकतम 6) और कठिनाई बढ़ती है।",
  'rules.spot.level1': "L1–L3 · 3–5 विकल्प · केवल नाम",
  'rules.spot.level2': "L4+ · 6 विकल्प · केवल नाम",
  'rules.spot.level3': "L10+ · 6 विकल्प · नाम + देश",
  'rules.spot.level4': "L20+ · 6 विकल्प · नाम + शहर + देश",
  'rules.spot.level5': "अनंत · गहराई के साथ स्कोर बढ़ता है · एक ग़लती से अंत",
  'rules.spot.tip1':   "विकल्प उसी महाद्वीप से आते हैं — ध्यान से पढ़ें।",
  'rules.spot.tip2':   "प्रतिष्ठित आकार (एफिल, पिरामिड) आसान — अंक गहराई से आते हैं।",
  'rules.spot.tip3':   "L10 से देश जुड़ता है; L20 से शहर भी।",

  "spot.region.title": "कहाँ खेलना चाहेंगे?",
  "spot.region.sub": "क्षेत्र चुनें। प्रसिद्ध स्थल आएँगे — सही उत्तर चुनकर आगे बढ़ें।",
  "spot.q.name": "यह कौन सा स्थल है?",
  "spot.q.namecountry": "नाम + देश?",
  "spot.q.namecity": "नाम + शहर + देश?",
  "spot.score": "स्कोर",
  "spot.choices": "विकल्प",
  "spot.correct": "सही",
  "spot.wrong": "ग़लत",
  "spot.points": "अंक",
  "spot.runTotal": "रन कुल",
  "spot.next": "अगला →",
  "spot.youPicked": "आपने चुना",
  "spot.finalScore": "अंतिम स्कोर",
  "spot.reachedLevel": "आप पहुँचे लेवल",
  "spot.tryAgain": "फिर से ↺",
  "spot.changeRegion": "क्षेत्र बदलें",
  "spot.mainMenu": "मुख्य मेनू",

  /* ─── Auth ─── */
  "auth.signIn": "साइन इन",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "साइन इन या अकाउंट बनाएँ",
  "auth.subtitle": "पासवर्ड नहीं — हम आपको ईमेल पर मैजिक लिंक भेजेंगे। नए हैं? अकाउंट अपने आप बनेगा।",
  "auth.send": "मैजिक लिंक भेजें",
  "auth.sending": "भेजा जा रहा है…",
  "auth.invalidEmail": "कृपया वैध ईमेल डालें।",
  "auth.sendFailed": "लिंक नहीं भेज सके। दोबारा कोशिश करें।",
  "auth.checkInbox": "अपना इनबॉक्स देखें",
  "auth.linkSentTo": "साइन-इन लिंक यहाँ जा रहा है:",
  "auth.spamHint": "नहीं मिला? स्पैम फ़ोल्डर देखें। लिंक 1 घंटे में समाप्त हो जाता है।",
  "auth.gotIt": "समझ गया",
  "auth.fineprint": "जारी रखकर आप हमारी शर्तें और गोपनीयता नीति स्वीकार करते हैं।",
  "auth.menu.profile": "मेरी प्रोफ़ाइल",
  "auth.menu.admin": "एडमिन",
  "auth.menu.signOut": "साइन आउट",
  "auth.callback.signingIn": "साइन इन हो रहा है…",
  "auth.callback.hold": "एक पल।",
  "auth.callback.welcome": "स्वागत है",
  "auth.callback.redirecting": "गेम्स पर ले जा रहे हैं…",
  "auth.callback.problem": "कुछ ग़लत हुआ",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "मेरी प्रोफ़ाइल",
  "profile.totalPoints": "कुल अंक",
  "profile.totalRuns": "खेली पारियाँ",
  "profile.gamesPlayed": "कोशिश किए गेम्स",
  "profile.editTitle": "प्रोफ़ाइल संपादित करें",
  "profile.displayName": "प्रदर्शित नाम",
  "profile.avatar": "अवतार",
  "profile.country": "देश (वैकल्पिक)",
  "profile.countryHint": "दो अक्षर का ISO कोड, जैसे IN, US, JP। लीडरबोर्ड झंडों के लिए।",
  "profile.save": "सहेजें",
  "profile.saving": "सहेज रहे हैं…",
  "profile.saved": "सहेजा गया",
  "profile.nameTooShort": "नाम कम से कम 2 अक्षरों का हो।",
  "profile.perGame": "प्रति गेम सर्वश्रेष्ठ",
  "profile.noRuns": "अभी तक कोई गेम नहीं — मेनू पर वापस जाकर एक चुनें।",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "लॉक",
  "common.needPoints": "{n} PTS चाहिए",
  "locked.pill": "लॉक",
  "locked.title": "{game} लॉक है",
  "locked.text": "{game} अनलॉक करने के लिए {remaining} अंक और चाहिए। उपलब्ध गेम्स खेलते रहें।",
  "locked.dismiss": "समझ गया",
  "spot.anon.playsLeft": "{n} मुफ़्त गेम्स बचे हैं — जारी रखने के लिए साइन इन करें।",
  "spot.anon.title": "आपने मुफ़्त गेम्स ख़त्म कर दिए",
  "spot.anon.text": "आपने {limit} में से {used} मुफ़्त गेम खेले हैं। जारी रखने के लिए साइन इन करें — मुफ़्त, बिना पासवर्ड, बस ईमेल मैजिक लिंक।",
  "spot.anon.signIn": "जारी रखने के लिए साइन इन →",
  "spot.anon.back": "मेनू पर वापस",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "अगला",
  "rules.next.unlocked": "अगला — अनलॉक",
  "rules.next.unlockedHint": "पर्याप्त अंक हैं — मेनू पर वापस जाएँ और खेलें।",
  "rules.next.needMore": "अनलॉक के लिए {remaining} अंक चाहिए — इस गेम को खेलते रहें।",
  "rules.next.signedOut": "अनलॉक के लिए {threshold} अंक कमाएँ — गिनती शुरू करने के लिए साइन इन करें।",
  "rules.next.premiumHint": "Premium से अनलॉक — Android beta के साथ।",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "झंडा + राष्ट्रगान",
  'games.audio.description': "राष्ट्रगान बजता है और देश का झंडा दिखता है। राजधानी पर पिन लगाओ। ",

  'rules.audio.goal':   "राष्ट्रगान सुनो और झंडा देखो। विश्व मानचित्र पर राजधानी पर जितना संभव हो सटीक पिन लगाओ।",
  'rules.audio.step1':  "क्षेत्र चुनें। पूल उस महाद्वीप तक सीमित।",
  'rules.audio.step2':  "राष्ट्रगान अपने आप बजता है। झंडा हमेशा दिखता रहता है।",
  'rules.audio.step3':  "टाइमर शून्य पर मानचित्र आता है। राजधानी पर पिन लगाओ।",
  'rules.audio.step4':  "दूरी सीमा के अंदर पास। ऊँचा लेवल = कम सुनना।",
  'rules.audio.level1': "10 sec · 1,000 km के अंदर",
  'rules.audio.level2': "8 sec · 500 km",
  'rules.audio.level3': "6 sec · 250 km",
  'rules.audio.level4': "4 sec · 100 km",
  'rules.audio.level5': "3 sec फ़्लैश · 50 km",
  'rules.audio.tip1':   "झंडा पहचानना आसान है — राजधानी सटीक रखना असली परीक्षा।",
  'rules.audio.tip2':   "कुछ राजधानियाँ सबसे बड़ा शहर नहीं (ब्रासीलिया, कैनबरा, ओटावा, प्रिटोरिया)।",
  'rules.audio.tip3':   "राष्ट्रगान की लय और वाद्य भी मदद करते हैं।",

  "audio.region.title": "कहाँ सुनना है?",
  "audio.region.sub": "एक क्षेत्र चुनें। आप राष्ट्रगान सुनेंगे और देश का झंडा देखेंगे — मानचित्र पर राजधानी पर पिन लगाएँ।",
  "audio.empty.title": "अभी तक कोई ऑडियो क्लिप नहीं",
  "audio.empty.text": "अभी कोई राष्ट्रगान उपलब्ध नहीं है — हम संग्रह तैयार कर रहे हैं। नए देशों को पहचानने के लिए जल्द ही वापस आएँ।",
  "audio.listen.hint": "झंडा और राष्ट्रगान पहचानते हो? राजधानी पर पिन लगाओ।",
  "audio.listen.skip": "काफ़ी सुना →",
  "audio.submit.ready": "जमा करें →",
  "audio.submit.empty": "पिन लगाने के लिए मानचित्र पर क्लिक करें",
  "audio.changeRegion": "क्षेत्र बदलें",

  /* ─── Empire ─── */
  "profile.empire.title": "मेरा साम्राज्य",
  "profile.empire.empty": "Audio Atlas या Landmark Quiz में किसी देश को पहचानकर हासिल करें। हर सही उत्तर पर साम्राज्य बढ़ता है।",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "ग्राइंड छोड़ें",
  "boost.tagline": "अंक खरीदें, तेज़ी से अनलॉक करें",
  "boost.description": "इंतज़ार नहीं करना? तीन पैक €2.99 से शुरू। अंक तुरंत आते हैं और हर अनलॉक में गिनते हैं।",
  "boost.cta": "अंक खरीदें",
  "shop.title": "अंक दुकान",
  "shop.sub": "ग्राइंड छोड़ें",
  "shop.buy": "खरीदें",
  "shop.opening": "खुल रहा है…",
  "shop.success": "भुगतान पुष्टि — अंक सेकंडों में जुड़ जाएँगे।",
  "shop.cancel": "रद्द किया गया — कोई शुल्क नहीं।",
  "shop.fineprint": "Stripe के माध्यम से एकल खरीद। पुष्टि के बाद तुरंत जुड़ता है। कोई सब्सक्रिप्शन नहीं।",
  "shop.boost.badge": "लोकप्रिय",
  "shop.power.badge": "सर्वोत्तम मूल्य",

  /* ─── Boost / Shop ─── */
};

export default hi;
